export const NOTIFICATIONS_OBSERVABLE_PRIVATE = Symbol('notifications-observable-private');
//# sourceMappingURL=privates.js.map